// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Ckzh","header":"ClearentDisclaimer_header__1WB5n","inner":"ClearentDisclaimer_inner__2L-ex"};